window.addEventListener('load', function () {
    document.querySelectorAll(".js-count-up").forEach((element) => {
        const { start, end, decimals, duration } = element.dataset;
        const countUp = new CountUp(
            element,
            start,
            end,
            decimals,
            duration,
            element.dataset
        );

        new Waypoint({
            element,
            handler: (direction) => {
                if (direction === "down") {
                    countUp.start();
                }
            },
            offset: "bottom-in-view"
        });
    });
});
